import { GENERIC_URL, customAxios, IDUSUARIO } from '../constants';
import { FETCH_TIPO_DOCUMENTO } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchTipoDocumento() {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
    params: {
      codGrupo: '44',
    },
  };

  const request = customAxios.get(`${GENERIC_URL}/logistica/maestro/listardatos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_TIPO_DOCUMENTO,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/TipoDocumento.js